<template>
    <v-card class="font-weight-bold pb-0 pt-0 mt-0 fill-height fight-report-card" style="font-size: large"
            :class="[$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03', getCardStyle()]"
            @touchstart.passive="onTabTouchStart"
            @touchend="onTabTouchEnd"
    >
        <EnvironmentPill :environment="fight.fightEnvironment" />
        <div class="fight-report-scale-wrap">
        <v-container v-if="fight.trainerPokemon" class="ma-0 pa-0 ">
            <v-row class="justify-center" style="height: 30px !important;">
                <v-avatar v-if="isTrainerFight" class=" chip-dekorator-dark lighten-1" dark fab width="40" height="40" style="font-size: 1.2em; position: absolute; left: 5px; top: 45px" :loading="isLoading">
                    {{isTrainerFight.usedPokemons}}/{{isTrainerFight.maxPokemons}}
                </v-avatar>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                            style="position: absolute; left: 50%; margin-left: -26px; top: 0px; border-radius: 50%; width: 52px; height: 52px; font-size: 1.5em; z-index: 150;" class="black chip-dekorator-white" :loading="isLoading">
                            <v-icon v-if="waiting && !showCountdown" color="white" size="28" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">mdi-timer-sand</v-icon>
                            <span v-else-if="waiting && showCountdown" style="color:white; font-size: 11px; font-weight: 700; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); white-space: nowrap;">{{ countdownText }}</span>
                            <span v-else style="color:white; font-size: 26px; position: relative; left: 11px; top: 15px;  border-radius: 50%;">
                                {{roundZero}}{{fight.round}}
                            </span>
                        </div>
                    </template>
                    <div style="max-width: 280px;" class="">{{ $t('journey.fightReport.roundsTooltip') }}</div>
                </v-tooltip>
                <v-avatar v-if="isTrainerFight" class="chip-dekorator-dark lighten-1" dark fab width="40" height="40" style="font-size: 1.2em; position: absolute; right: 5px; top: 45px;" :loading="isLoading">
                    {{isTrainerFight.opponentUsedPokemons}}/{{isTrainerFight.maxPokemons}}
                </v-avatar>
                <div v-if="fight.bossFight" style="position: absolute; right: 5px; top: 5px; border-radius: 16px;  width: 100px; height: 30px; background-color: #0a0a0a">
                    <div
                        class="black text-center align-center d-flex justify-center golden"
                        style="font-size: 22px; border-radius: 16px;  width: 100px; height: 30px; box-shadow:0 0 6px 2px #fff, inset 0 0 5px 3px #f8ca7c, 0 0 6px 2px #f5e47c;"
                        :loading="isLoading">
                        {{ $t('journey.fightReport.bossLabel') }}
                    </div>
                </div>
            </v-row>
            <!-- pt-12 rezerva pod EnvironmentPill (position:absolute, viz níže) - bez ní pilulka
                 překrývá LAST ROUND baner. -->
            <div v-if="!fight.fightReport2.beforeFight" class="pt-12">
                <FightReportDuel
                    v-if="activeTab === 'report'"
                    :fight="fight"
                    @open-roll-popup="rollPopup = $event"
                    @open-skill-popup="openSkillPopup"
                />
                <FightReportHistory v-if="activeTab === 'history'" :round-log="fight.roundLog || []" />
                <div v-if="activeTab === 'trainer'" class="fight-report-trainer-tab text-center">
                    <FightReportTrainerMini :trainer="opponentTrainerObj" />
                </div>
            </div>
            <div v-if="availableTabs.length > 1" class="fight-report-tab-dots">
                <span
                    v-for="tab in availableTabs"
                    :key="tab"
                    class="fight-report-tab-dot"
                    :class="{'fight-report-tab-dot--active': activeTab === tab}"
                />
            </div>
        </v-container>
        <v-card-text v-else class="ma-0 pa-0" style="position:relative; top:  0px; z-index: 0;">
           <!-- EnvironmentPill (první sourozenec) je position:absolute bez top - obsah pod ní
                potřebuje vlastní horní rezervu (pt-9), stejně jako v-if větev výše. -->
           <v-row v-if="isTrainerFight && fight.active" class="justify-center black--text pt-9">
               <v-card-text class="text-center pa-0 ma-0">
                   <v-card-title v-if="position && position.trainerFight" class="text-center justify-center ma-0 pa-0">
                       <TrainerBlock
                           key="trainer"
                           :reverse="true"
                           v-if="position.trainerFight"
                           :trainer-id="position.trainerFight.trainer.id"
                           :stadion-fight-report="isTrainerFight"
                       />
                   </v-card-title>
               </v-card-text>
           </v-row>
        </v-card-text>
        </div>

        <!-- Roll/skill popup jsou sourozenci .fight-report-scale-wrap, ne potomci - scale-wrap
             může mít transform:scale(), což by "fixed" potomky oříznulo/scalovalo spolu s reportem. -->
        <div v-if="rollPopup" class="fight-report-duel__popup-overlay" @click.self="rollPopup = null">
            <div class="fight-report-duel__popup-box">
                <FightReportDiceBreakdown
                    bare
                    :label="rollPopup.label"
                    :dice="rollPopup.dice"
                    :flat-bonus="rollPopup.flatBonus"
                    :total="rollPopup.total"
                    :bonus-dice="rollPopup.bonusDice"
                    :bonus-flat="rollPopup.bonusFlat"
                >
                    <template v-if="rollPopup.notes.length" #notes>
                        <div v-for="(note, i) in rollPopup.notes" :key="i" class="fight-report-duel__note">{{ note }}</div>
                    </template>
                </FightReportDiceBreakdown>
            </div>
        </div>
        <SkillDetailPopup v-model="skillPopupOpen" :skill="skillPopupSkill" />
    </v-card>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TrainerBlock from "@/components/trainer/TrainerBlock";
import EnvironmentPill from "@/components/journey/positions/battle/EnvironmentPill";
import FightReportDuel from "@/components/journey/positions/fight/FightReportDuel";
import FightReportHistory from "@/components/journey/positions/fight/FightReportHistory";
import FightReportDiceBreakdown from "@/components/journey/positions/fight/FightReportDiceBreakdown";
import FightReportTrainerMini from "@/components/journey/positions/fight/FightReportTrainerMini";
import SkillDetailPopup from "@/components/pokedex/SkillDetailPopup";
import {API_ENTRYPOINT} from "@/config/entrypoint";

// Vizuál "reportu" (kolo, prostředí, výměna zranění, počet použitých pokémonů) - výběr/použití
// skillu řeší SkillActionBar.vue napojené přímo v BattleScreen.vue. Design viz
// claude/components/battle-skills.md.
export default {
        name: "FightReport",
        components: {TrainerBlock, EnvironmentPill, FightReportDuel, FightReportHistory, FightReportDiceBreakdown, FightReportTrainerMini, SkillDetailPopup},
        props: {
            fight: {Object, default: null},
            trainer: {Object, default: null},
            position: {Object, default: null},
            isTrainerFight: {Object, default: null},
            // PvP-only - kolečko s číslem kola se místo toho vyplní přesýpacími hodinami/countdownem.
            waiting: {type: Boolean, default: false},
            // "Nepřátelský trenér" záložka - PvP explicitní override (nemá position vůbec).
            opponentTrainerId: {type: Number, default: null},
            // PvP-only (PvpPokemonFight::roundDeadlineAt) - HH:MM countdown vedle přesýpacích hodin.
            deadline: {type: String, default: null},
        },
        data() {
            return {
                activeTab: 'report',
                tabTouchStartX: null,
                rollPopup: null,
                skillPopupOpen: false,
                skillPopupSkill: null,
                // Lazy-načtený cizí Trainer objekt pro záložku "Nepřátelský trenér".
                opponentTrainerObj: null,
                showCountdown: false,
                countdownTimer: null,
                // Reaktivní závislost pro countdownText computed - Date.now() není sledovaná Vue
                // hodnota, bez tickeru by se text po prvním výpočtu zamrznul.
                countdownTick: 0,
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'journey/isLoading',
                user: 'user/item',
            }),
            roundZero() {
                if (this.fight.round < 10)
                    return "0"
                else
                    return "";
            },
            // Singleplayer trenérský fight má id v position, PvP ho posílá explicitně (nemá position).
            resolvedOpponentTrainerId() {
                if (this.opponentTrainerId) {
                    return this.opponentTrainerId;
                }
                if (this.isTrainerFight && this.position && this.position.trainerFight) {
                    return this.position.trainerFight.trainer.id;
                }
                return null;
            },
            availableTabs() {
                const tabs = ['report', 'history'];
                if (this.resolvedOpponentTrainerId) {
                    tabs.push('trainer');
                }
                return tabs;
            },
            countdownText() {
                this.countdownTick;
                if (!this.deadline) {
                    return '';
                }
                const diffMs = new Date(this.deadline).getTime() - Date.now();
                const totalMinutes = Math.max(0, Math.floor(diffMs / 60000));
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;
                return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
            },
        },
        watch: {
            activeTab(tab) {
                if (tab === 'trainer' && !this.opponentTrainerObj) {
                    this.loadOpponentTrainer();
                }
            },
        },
        mounted() {
            this.countdownTimer = setInterval(() => {
                this.countdownTick++;
                this.showCountdown = !!(this.waiting && this.deadline) && !this.showCountdown;
            }, 2500);
        },
        beforeDestroy() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
            }
        },
        methods: {
            ...mapActions({
                fetchTrainerObject: 'trainer/fetchObject',
            }),
            loadData() {
            },
            loadOpponentTrainer() {
                if (!this.resolvedOpponentTrainerId) {
                    return;
                }
                const url = new URL('api/trainers/' + this.resolvedOpponentTrainerId, API_ENTRYPOINT);
                this.fetchTrainerObject({url, method: 'GET'}).then((data) => {
                    if (data) {
                        this.opponentTrainerObj = data;
                    }
                });
            },
            openSkillPopup(skill) {
                this.skillPopupSkill = skill;
                this.skillPopupOpen = true;
            },
            onTabTouchStart(event) {
                this.tabTouchStartX = event.touches[0].clientX;
            },
            onTabTouchEnd(event) {
                if (this.tabTouchStartX === null) {
                    return;
                }
                const deltaX = event.changedTouches[0].clientX - this.tabTouchStartX;
                this.tabTouchStartX = null;
                const SWIPE_THRESHOLD_PX = 40;
                if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX) {
                    return;
                }
                const tabs = this.availableTabs;
                const currentIndex = tabs.indexOf(this.activeTab);
                const step = deltaX < 0 ? 1 : -1;
                const nextIndex = ((currentIndex === -1 ? 0 : currentIndex) + step + tabs.length) % tabs.length;
                this.activeTab = tabs[nextIndex];
            },
            getCardStyle() {
                if (this.fight.fightEnvironment && this.fight.fightEnvironment.type) {
                    return ' chip-dekorator-dark-small white--text text-no-wrap color-type-card-dekor-'+this.fight.fightEnvironment.type.id.toLowerCase();
                } else if (this.fight.fightEnvironment) {
                    return ' chip-dekorator-dark-small white--text text-no-wrap ';
                } else {
                    return '';
                }
            },
        },
    }
</script>

<style scoped>
.fight-report-tab-dots {
    display: flex;
    justify-content: center;
    gap: 6px;
    padding: 4px 0 2px 0;
}
.fight-report-tab-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(128, 128, 128, 0.4);
}
.fight-report-tab-dot--active {
    background: rgba(128, 128, 128, 0.9);
}
.fight-report-trainer-tab {
    min-height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fight-report-card {
    position: relative;
    overflow: hidden !important;
}
.fight-report-scale-wrap {
    /* position:absolute vyjímá wrapper z normálního toku, aby jeho výška neovlivňovala výšku
       .fight-report-card (ta má vlastní výšku z flex kontextu BattleLayout.vue). */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}
.fight-report-duel__note {
    font-size: 10px;
    opacity: 0.85;
    margin-top: 5px;
    color: #fff;
    /* .fight-report-card může mít Vuetify text-no-wrap (viz getCardStyle) - dědí se na potomky,
       reset tady zajistí zalamování dlouhých poznámek. */
    white-space: normal;
    overflow-wrap: break-word;
}
.fight-report-duel__popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(0, 0, 0, 0.35);
    cursor: pointer;
}
.fight-report-duel__popup-box {
    max-width: min(90vw, 380px);
    width: 100%;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(2px);
    color: #fff;
    padding: 16px 18px;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
    cursor: default;
}
</style>

